import { Renderer2 } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { publicEventApi } from 'src/app/shared/constants/api.constants';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpBaseService } from '@evento-ng/libs';

@Component({
  selector: 'app-new-booking',
  templateUrl: './new-booking.component.html',
  styleUrls: ['./new-booking.component.scss'],
})
export class NewBookingComponent {
  eventId: any;
  event: any;
  showCustomForm = false;
  showInfoForm = false;
  customFormDetails: any;
  showReview = false;
  showCartMobile = false;
  isMobile = false;
  invoice: any = null;
  private pixelScript: HTMLScriptElement | undefined;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private ticketService: TicketService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {
    this.ticketService.bookTicket.next(null);
    this.route.queryParams.subscribe((res) => {
      this.eventId = res.eventId;
    });
  }

  ngOnInit() {
    this.getEventDetails();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  setCartMobile(value) {
    this.showCartMobile = value;
  }

  getEventDetails() {
    this.spinner.show();
    this.dataService
      .get(`${publicEventApi}/${this.eventId}`)
      .subscribe((res) => {
        this.spinner.hide();
        this.event = res;
        if (this.event.id == '37e530c8-6db8-4dec-9a9b-77510e6301d5') {
          this.loadTikTokPixel();
        }
      });
  }

  goToCustomForm(event) {
    this.showInfoForm = false;
    this.customFormDetails = event;
    this.showCustomForm = true;
  }

  goToInfoForm(event) {
    this.showCustomForm = false;
    this.showInfoForm = true;
  }

  goToReview() {
    this.showCustomForm = false;
    this.showInfoForm = false;
    this.showReview = true;
  }

  loadTikTokPixel() {
    this.pixelScript = this.renderer.createElement('script');
    this.pixelScript.type = 'text/javascript';
    this.pixelScript.text = `
        !function(w,d,t){
            w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
            ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];
            ttq.setAndDefer=function(t,e){
                t[e]=function(){
                    t.push([e].concat(Array.prototype.slice.call(arguments,0)))
                }
            };
            for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
            ttq.instance=function(t){
                for(var e=ttq._i[t]||[],n=0;n<e.length;n++)ttq[e[n][0]].apply(ttq,e[n].slice(1));
                return ttq
            };
            ttq.load=function(e,n){
                var i="https://analytics.tiktok.com/i18n/pixel/events.js";
                ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date;
                ttq._o=ttq._o||{},ttq._o[e]=n||{};
                var o=document.createElement("script");
                o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;
                var a=document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(o,a)
            };
            ttq.load('CV34QGRC77UD0HO3EIPG');
            ttq.page();
        }(window,document,'ttq');
    `;

    this.renderer.appendChild(document.head, this.pixelScript);
    this.trackEvent();
  }
  trackEvent() {
    (window as any).ttq.track('Book', {
      content_name: this.event.nameAr,
      content_category: 'Event',
    });
  }
  ngOnDestroy(): void {
    if (this.pixelScript) {
      this.renderer.removeChild(document.head, this.pixelScript);
      this.pixelScript = undefined;
    }
    window['ttq'] = undefined; // Optional: clear the ttq object
  }
}
